export default () => {
  return {
    state: {},
    actions: {},
    mutations: {},
    getters: {},
    middlewares: {},
  }
}
